// Limpieza de los textos que carga el usuario en los formularios.
//
// Motivo: las columnas de texto de la base (nombre, apellido, calle, email, etc.)
// están en utf8 de 3 bytes, así que cualquier emoji -que ocupa 4- rompe el insert
// o se guarda cortado. Además los textos pegados desde WhatsApp / Word suelen
// traer caracteres invisibles que después ensucian etiquetas, mails y reportes.

// 1) Todo lo que está fuera del plano básico (emojis, banderas, pictogramas nuevos)
//    más los surrogates sueltos que puedan quedar de un texto mal pegado.
const FUERA_DEL_PLANO_BASICO = /[\u{10000}-\u{10FFFF}\uD800-\uDFFF]/gu;

// 2) Emojis y pictogramas que sí entran en el plano básico
//    (☀ ★ ✈ ❤ ✔ ➡ ⌚ ™ © ®, flechas, etc.) + selectores de variante y keycaps.
const SIMBOLOS_PICTOGRAFICOS = /[\u00A9\u00AE\u203C\u2049\u20E3\u2122\u2139\u2194-\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u27BF\u2934\u2935\u2B00-\u2BFF\u3030\u303D\u3297\u3299\uFE00-\uFE0F]/g;

// 3) Caracteres invisibles: espacios de ancho cero, marcas de dirección de texto,
//    guión suave y BOM.
const INVISIBLES = /[\u00AD\u200B-\u200F\u2028\u2029\u202A-\u202E\u2060-\u2064\uFEFF]/g;

// 4) Caracteres de control (se conservan tabulación y salto de línea).
// eslint-disable-next-line no-control-regex
const CONTROL = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F]/g;

/**
 * Devuelve el texto sin emojis, símbolos pictográficos ni caracteres invisibles.
 * Cualquier valor que no sea string se devuelve tal cual.
 */
export const sanitizarTexto = (valor) => {
    if (typeof valor !== 'string' || valor === '') {
        return valor;
    }

    return valor
        .replace(FUERA_DEL_PLANO_BASICO, '')
        .replace(SIMBOLOS_PICTOGRAFICOS, '')
        .replace(INVISIBLES, '')
        .replace(CONTROL, '');
}

/**
 * Helper para los onChange: sanitiza el valor del evento.
 */
export const valorSanitizado = (event) => sanitizarTexto(event?.target?.value);

export default sanitizarTexto;
